module.exports = __webpack_public_path__ + "img/chart.30a9e851.png";